<script>
import DealGrid from '@/views/crm/deals/Grid';

export default {
    name: 'RatingDealsGrid',
    data() {
        return {
            headerOptions: {
                isUnreadMessagesCountVisible: false,
                isFilterVisible: false,
                isNewButtonVisible: false,
                isGoBackButtonVisible: true,
                isExcelButtonVisible: false
            },
            title: 'Список сделок по выбранному показателю рейтинга',
            filterModel: {
                ids: []
            },
            fieldsNames: {
                ids: 'ид'
            }
        };
    },
    extends: DealGrid,
    computed: {
        dealIds() {
            return this.$store.state.analytics.dealIds || [];
        }
    },
    mounted() {
        this.checkDealIdsProp();
        this.setFilter();
        this.getDataFromServer();
    },
    methods: {
        checkDealIdsProp() {
            if (!this.dealIds || !this.dealIds.length) {
                this.$router.push({ name: 'analytics-employers-rating' });
            }
        },
        setFilter() {
            this.filterModel.ids = [...this.dealIds];
        },
        loadSettings() {
            //not load settings(override parent method)
        },
        saveSetting() {
            //not save settings(override parent method)
        }
    }
};
</script>
